"use client";

import { useTranslations } from "next-intl";

type Block =
  | { type: "p"; text: string }
  | { type: "h"; text: string }
  | { type: "list"; items: string[] };

type Section = { heading: string; body: Block[] };

export function LegalDocument({ namespace }: { namespace: string }) {
  const t = useTranslations(namespace);
  const tCommon = useTranslations("legal");
  const intro = t.raw("intro") as string[];
  const sections = t.raw("sections") as Section[];

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1
        className="text-3xl font-bold tracking-tight"
        style={{ color: "var(--color-text)" }}
      >
        {t("title")}
      </h1>
      <p className="mt-2 text-xs" style={{ color: "var(--color-subtle)" }}>
        {tCommon("effectiveDate", { date: tCommon("date") })}
      </p>

      <div className="mt-6 space-y-3">
        {intro.map((paragraph) => (
          <p key={paragraph} className="text-sm leading-7" style={{ color: "var(--color-muted)" }}>
            {paragraph}
          </p>
        ))}
      </div>

      <div className="mt-10 space-y-8">
        {sections.map((section, index) => (
          <section key={section.heading}>
            <h2
              className="text-lg font-semibold tracking-tight"
              style={{ color: "var(--color-text)" }}
            >
              {index + 1}. {section.heading}
            </h2>
            <div className="mt-3 space-y-3">
              {section.body.map((block, blockIndex) => {
                if (block.type === "list") {
                  return (
                    <ul
                      key={blockIndex}
                      className="list-disc pl-5 space-y-1.5 text-sm leading-7"
                      style={{ color: "var(--color-muted)" }}
                    >
                      {block.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  );
                }
                if (block.type === "h") {
                  return (
                    <h3
                      key={blockIndex}
                      className="pt-2 text-sm font-semibold"
                      style={{ color: "var(--color-text)" }}
                    >
                      {block.text}
                    </h3>
                  );
                }
                return (
                  <p
                    key={blockIndex}
                    className="text-sm leading-7"
                    style={{ color: "var(--color-muted)" }}
                  >
                    {block.text}
                  </p>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </article>
  );
}
